var path = 'components/dashboard-select-panel.tpl.html';
var html = " <md-content flex layout=column> <section flex layout=column> <md-content flex class=md-padding layout=column> <md-input-container flex> <label>{{ 'dashboard.select-dashboard' | translate }}</label> <md-select ng-model=vm.dashboardId ng-change=vm.dashboardSelected(vm.dashboardId)> <md-option ng-repeat=\"dashboard in vm.dashboards\" ng-value=dashboard.id.id> {{dashboard.title}} </md-option> </md-select> </md-input-container> </md-content> </section> </md-content> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard-select-panel.tpl.html
// module id = 1378
// module chunks = 1